import * as STD from '@emersya/mpa-std';
import * as CM from '@emersya/mpa-components-manager';

export interface IColorComponentConfiguration extends CM.DOMComponent.IConfiguration {
	color: string | null;
};

export class ColorComponent extends CM.DOMComponent<
	HTMLDivElement,
	ColorComponent,
	IColorComponentConfiguration
> {
	component_DOM: HTMLDivElement;
	color: STD.colors.TColor |null = null;

	update(color: string | null) {
		this.color = color ? STD.colors.Color.create(color) : null;
		this.component_stylize({
			backgroundColor: this.color ? this.color.toCSS() : ''
		});
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: IColorComponentConfiguration
	) {
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement>STD.DOM.factory({});
		this.update(configuration.color);
	};
};
export namespace NS {
	export const Component = ColorComponent;
	export type Component = ColorComponent;
	export type Configuration = IColorComponentConfiguration;
}

import './Color.scss';

CM.Manager.declare({
	id: 'color',
	type: ColorComponent
});
